// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__wZh5g","buttons":"tabs_buttons__NSa7Q","content":"tabs_content__-xAhb","fullSize":"tabs_fullSize__hK0yj","fixedHeight":"tabs_fixedHeight__NEuwZ"};